<template>
  <div>    
    <base-title :title="StringLanguage.keys" :subtitle="StringLanguage.configurations" :link="'configuracoes'"/>

    <base-box>
        <base-checkbox :label="StringLanguage.disableFacebookLogin" v-model="keys.disable_facebook_login" :checked="keys.disable_facebook_login"/>
    </base-box>    

    <base-box>
        <base-checkbox :label="StringLanguage.showEmptyCategoriesOnEcommerce" v-model="keys.show_products_on_start" :checked="keys.show_products_on_start"/>
    </base-box>

    <!-- <div class="d-flex justify-end w-100 mt_15">
      <base-button :text="StringLanguage.save" @click="save"/>
    </div> -->
  </div>
</template>

<script>
import Keys from "@/plugins/core/schema/configurations/Keys/Keys"
import StoreAPI from '@/api/store'
import Vue from 'vue'

import BaseTitle from '@/components/Title'
import BaseButton from '@/components/Button'
import BaseBox from '@/components/Box'
import BaseCheckbox from '@/components/Checkbox'

export default {
  data() {
    return { 
      keys: new Keys(),
      originalData: null
    }
  },
  components: {
    BaseTitle,
    BaseButton,
    BaseBox,
    BaseCheckbox,
  },
  created() {
    let self = this
    StoreAPI.storeGetConfiguration('keys').then((response) => {
        self.set(response);
    })
  },
  beforeDestroy () {
    if(JSON.stringify(this.originalData) != JSON.stringify(this.keys)) {
      this.save()
    } 
  },
  methods: {
    set(response) {
      if(response.getErrors([]).length > 0) {
        return false
      } else if(response.getData({}).keys || false) {
        let keys = response.getData(new Keys).keys;
        Vue.set(this, 'keys', new Keys(
          keys.disable_facebook_login, 
          keys.show_products_on_start, 
        ));
        Vue.set(this, 'originalData', new Keys(
          keys.disable_facebook_login, 
          keys.show_products_on_start, 
        ));
      } else {
        Vue.set(this, 'keys', new Keys());
        Vue.set(this, 'originalData', new Keys());
      }
    },
    save() {
      let self = this;
      StoreAPI.storeConfiguration({
        'keys': this.keys
      }).then((response) => {
        this.$store.dispatch('store/getConfigurations')
        self.set(response)
      })
    }
  }
}
</script>